import * as React from "react";
import { Input, Button, Form, Alert, message, Select } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { User } from "../UserDetails";
import RolesQuery from "src/queries/RolesQuery";

const FormItem = Form.Item;

interface FormValues {
  email: string;
  name: string;
  firstName: string;
  surName: string;
  phone: string;
  postalCode: string;
  street: string;
  city: string;
  roles: string[];
}

export interface Props extends FormComponentProps {
  user: User | null;
  admin: boolean;
  // tslint:disable-next-line:no-any
  onSubmit(values: FormValues): Promise<void | any>;
}

export interface State {
  loading: boolean;
  error: string | null;
  success: string | null;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

class EditUserFields extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { loading: false, error: null, success: null };
  }
  handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    this.props.form.validateFields((err, values: FormValues) => {
      if (!err) {
        delete values.name;
        this.setState({ loading: true, error: null, success: null });
        this.props
          .onSubmit(values)
          .then(() => {
            this.props.form.resetFields();
            this.setState({ loading: false, success: "User changed!" });
            message.success("User information updated");
          })
          .catch(r => {
            console.log(r);
            this.setState({ loading: false, error: r.toString() });
          });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        {this.state.error && (
          <Alert message={this.state.error} type="error" showIcon={true} />
        )}
        <FormItem label="Username" {...formItemLayout}>
          {getFieldDecorator("name", {
            initialValue: this.props.user && this.props.user.name
          })(<Input readOnly={true} />)}
        </FormItem>
        <FormItem label="Name" {...formItemLayout}>
          {getFieldDecorator("firstName", {
            rules: [
              { required: true, message: "Please input your first name!" }
            ],
            initialValue: this.props.user && this.props.user.firstName
          })(<Input />)}
        </FormItem>
        <FormItem label="Surname" {...formItemLayout}>
          {getFieldDecorator("surName", {
            rules: [
              { required: true, message: "Please input your last name!" }
            ],
            initialValue: this.props.user && this.props.user.surName
          })(<Input />)}
        </FormItem>
        <FormItem label="Email" {...formItemLayout}>
          {getFieldDecorator("email", {
            rules: [{ required: true, message: "Please input your email!" }],
            initialValue: this.props.user && this.props.user.email
          })(<Input />)}
        </FormItem>
        <FormItem label="Phone" {...formItemLayout}>
          {getFieldDecorator("phone", {
            rules: [
              { required: true, message: "Please input your phone number!" }
            ],
            initialValue: this.props.user && this.props.user.phone
          })(<Input />)}
        </FormItem>
        <FormItem label="Street" {...formItemLayout}>
          {getFieldDecorator("street", {
            rules: [
              {
                required: true,
                message: "Please input your street and number!"
              }
            ],
            initialValue: this.props.user && this.props.user.street
          })(<Input />)}
        </FormItem>
        <FormItem label="City" {...formItemLayout}>
          {getFieldDecorator("city", {
            rules: [{ required: true, message: "Please input your city!" }],
            initialValue: this.props.user && this.props.user.city
          })(<Input />)}
        </FormItem>
        <FormItem label="Postal Code" {...formItemLayout}>
          {getFieldDecorator("postalCode", {
            rules: [
              { required: true, message: "Please input your postalCode!" }
            ],
            initialValue: this.props.user && this.props.user.postalCode
          })(<Input />)}
        </FormItem>
        <FormItem label="User Roles" {...formItemLayout}>
          <RolesQuery>
            {({ loading, error, data }) => {
              return getFieldDecorator("roles", {
                initialValue:
                  (this.props.user &&
                    this.props.user.roles &&
                    this.props.user.roles.map(r => r.name)) ||
                  []
              })(
                <Select
                  loading={loading}
                  disabled={!this.props.admin}
                  mode="multiple"
                  style={{ width: "100%" }}
                >
                  {data &&
                    data.roles &&
                    data.roles.map(
                      s =>
                        s && (
                          <Select.Option key={s.name}>{s.name}</Select.Option>
                        )
                    )}
                </Select>
              );
            }}
          </RolesQuery>
        </FormItem>
        <FormItem>
          <Button loading={this.state.loading} htmlType="submit" type="danger">
            {this.props.user ? "Update" : "Create"}
          </Button>
        </FormItem>
      </Form>
    );
  }
}
export default Form.create<Props>()(EditUserFields);



// WEBPACK FOOTER //
// ./src/components/UserDetails/EditUserFields/EditUserFields.tsx